// Translations
import landing from '../views/landing/translations/en'

// Translation: Register (English)
export default Object.freeze({
	name: 'Register',
	views: { landing }
})
